import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';

const ServiceProfileVisibleScope = ({ options, darkMode, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    const visibleScopeData = (options || []).map((opt) => ({
        ...opt,
        id: opt.value,
        name: opt.label,
    }));
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Visible Scope{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Determine visibility and service creation level.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <Field
                                name="visibleScope"
                                validate={(value) =>
                                    !value && 'Please select a visible scope'
                                }>
                                {({ field, meta }) => (
                                    <>
                                        <DropDown
                                            id="visibleScope"
                                            field={field}
                                            name="visibleScope"
                                            data={visibleScopeData}
                                            shownValue="name"
                                            alphabetical={false}
                                            isClearable={false}
                                            noPadding
                                            walkthroughId={
                                                walkthroughIds.serviceProfiles
                                                    ?.ufVisibleScopeSelect
                                            }
                                            darkMode={darkMode}
                                            width="100%"
                                            placeholder="- Select Visible Scope -"
                                            handleSelectChange={(item) =>
                                                props.onChange(item)
                                            }
                                        />
                                        {meta.touched && meta.error && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                                textAlign="right">
                                                {meta.error}
                                            </Text>
                                        )}
                                    </>
                                )}
                            </Field>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Determine visibility and service creation level."
                        ariaLabel="service-profile-visible-scope-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ServiceProfileVisibleScope;
